const indentListing = require('./indent/listing');
const transporterIndentListing = require('./indent/transporter-listing');

module.exports = {
  'shipper-indent-listing': indentListing,
  'transporter-indent-listing': transporterIndentListing,
  'indent-details': {},
};
